@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

.firstContainer {
  margin-top:10px;
  display: block;
  overflow: auto;
  margin-left:0px;
  @include breakpoints.desktop {
    margin-top: 40px;
    margin-left: 35px;    
  }
}
.containerLeft {
  // background: var(--white);
  float: left;
  padding: 10px 20px;
  width: 100%;
  @include breakpoints.desktop {
    max-width: 50%;
    width: 50%;
    padding: 0px;
  }
  @include breakpoints.desktop-medium {
    max-width: 50%;
    width: 50%;
    padding: 0px;
  }
  @include breakpoints.desktop-large {
    max-width: 50%;
    width: 50%;
    padding: 0px;
  }
}

.containerRight {
  // background: var(--white);
  float: right;
  width: 100%;
  padding: 10px 20px 0px 20px;
  @include breakpoints.desktop {
    max-width: 50%;
    width: 50%;
    padding: 0px;
  }
  @include breakpoints.desktop-medium {
    max-width: 50%;
    width: 50%;
    padding: 0px;
  }
  @include breakpoints.desktop-large {
    max-width: 43%;
    width: 43%;
    padding: 0px;
  }
}

.editContainer {
  float: right;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  display: flex;
  align-items: center;
  letter-spacing: 0.02em;
  text-decoration-line: underline;
  color: var(--blue-01);
  cursor:pointer;
  @include breakpoints.desktop {
    font-weight: 600;
  }
}


.patientDesktop {
  background: var(--white);
  display: block;
  overflow: auto;
  margin-top:20px;
  margin-left: 35px;
  display: none;
  @include breakpoints.desktop {
    display: block;
  }
}
.patientMobile {
  background: var(--white);
  display: block;
  overflow: auto;
  margin-top:20px;
  margin-left: 20px;
  display: block;
  @include breakpoints.desktop {
    display: none;
  }

  .nameContainer {
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--black);
    padding-bottom: 15px;
  }

  .patientContainer {
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: flex-end;
    letter-spacing: 0.02em;
    color: var(--black);
    padding-bottom: 15px;
  }
}
.headerSection {
  height:35px;
  text-transform: uppercase;
  padding-top: 5px;
  width: 100%;
  @include breakpoints.desktop {
    width: 90%;
  }
  @include breakpoints.desktop-medium {
    width: 90%;
  }
  @include breakpoints.desktop-large {
    width: 79%;
  }
}


.headline {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  display: block;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  text-align: left;
  color: var(--pure-black);
  margin: 0px;
  margin-left: 20px;
  padding: 10px 0px;
  @include breakpoints.desktop {
    font-size: 24px;
    padding: 0px;
    margin-left: 35px;
  }
}

.heading {
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--blue-01);
  float:left;
  @include breakpoints.desktop {
    font-size: 20px;
  }
}

.heading1 {
  position: absolute;
  width: auto;
  height: 36px;
  left: calc(50% - 430px/2 - 470px);
  top: 152px;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 150%;
  display: flex;
  align-items: center;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--pure-black);
}
.leftside {
  position: absolute;
  width: 380.53px;
  height: 25px;
  left: calc(50% - 380.53px/2 - 491.74px);
  top: 280px;
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: var(--black);
}

.selectOffice {
  position: absolute;
  width: 204px;
  height: 30px;
  left: 39px;
  top: 234px;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--blue-01);
}

.action {
  color: var(--blue-01);
  float:right;
  width:20%;
  padding: 1px 10px 0px 0px;
  text-align: right;
  text-decoration: underline;
}

.contentSection {
  padding: 10px 0px 0px 0px;
  display: block;
  overflow: auto;
  @include breakpoints.desktop {
    padding: 10px 0px;
  }
}

.contentLeft {
  float:left;
  width: 55%;
}

.line {
  width: 100%;
  height: 0px;
  border: 1px solid var(--gray-06);
  display: block;
  overflow: auto;  
}

.pdetailsLin {
  width: 100%;
  height: 0px;
  /* border: 1px solid var(--gray-06); */
  display: block;
  overflow: auto;
}

.contentRight {
  float:right;
  width:45%;
  text-align: right;
  padding-left: 15px;
}

.officeName {
  font-style: normal;
  font-weight: 600;
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: var(--black);
  display: block;
}

.officeAddress {
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: var(--black);
  padding-bottom: 20px;
  @include breakpoints.desktop {
    padding-bottom: 0px;
  }
}

.officePhone {
  color: var(--blue-01);
  font-size: 12px;
  font-weight: 400;
}

.patientOne {
  width: 50%;
  display:block;
  overflow: auto;
  margin-bottom: 40px;

  .firstName {
    width: 64%;
    float: left;
  }

  .lastName {
    width: 35%;
    float: left;
  }
}

.patientTwo {
  width: 100%;
  display:block;
  overflow: auto;
  margin-bottom: 30px;

  .phoneNumber {
    width: 32%;
    float: left;
  }

  .email {
    width: 25%;
    float: left;
  }

  .dob {
    width: 25%;
    float: left;
  }
}

.icon {
  margin-right: 5px;
}

.buttonClassmobile {
  display: block;
  margin: 20px;
  @include breakpoints.desktop {
    display: none;
  }
  button {
    min-height: 50px;
    font-size: 20px;
    width: 100%;
    @include breakpoints.desktop {
      margin: 10px 0px -5px 0px;
      min-height: 36px;
      font-size: 16px;
      width: 200px;
    }
  }
}

.buttonClass {
  width: 100%;
  display: none;
  @include breakpoints.desktop {
    display: block;
  }
  button {
    min-height: 50px;
    font-size: 20px;
    width: 100%;
    @include breakpoints.desktop {
      margin: 10px 0px -5px 0px;
      min-height: 36px;
      font-size: 16px;
      width: 200px;
    }
  }
}

.submitButton {
  position: absolute;
  left: 0%;
  right: 0%;
  top: 0%;
  bottom: 0%;
  background: var(--blue-01);
  border-radius: 4px;
}

.timings {
  color: var(--blue-01);
  font-size: 12px;
  font-weight: 400;
}

.doctorContainer {
  margin-left: 0px;
  @include breakpoints.desktop {
    margin-left: 0px;
  }

  img {
    float:left;
  }
  .doctorDetails{
    margin-left: 10px;
    float:left;
    @include breakpoints.desktop {
      margin-left: 20px;
    }
  }
}

.patientEdit {
  width: 100%;
  padding-right: 20px;
  @include breakpoints.desktop {
    width: 95%;
    padding-right: 0px;
  }
  @include breakpoints.desktop-medium {
    width: 95%;
    padding-right: 0px;
  }
  @include breakpoints.desktop-large {
    width: 89%;
    padding-right: 0px;
  }
}

.modal {
  max-width: 518px;
}

.borderDivider {
  border: 1px solid rgba(0, 51, 102, 0.3);
  display: block;
  overflow: auto;
  @include breakpoints.desktop {
    display: none;
  }
}

.mobileBottomLin {
  bottom: 90px;
  position: fixed;
  @include breakpoints.desktop {
    bottom: auto;
    position: initial;
  }
}

.medicaid {
  background-color: aliceblue;
  padding: 5px;
  margin: 5px 20px;
  @include breakpoints.desktop {
    margin: 5px 35px;
  }
}

.retiringContent{
  margin-bottom: 15px;
  @include breakpoints.desktop {
    margin-bottom: 0px;
  }
}

.retiringContainer{
  display: block;
  overflow: auto;
}

.reviewModal {
  padding: 0px;
  @include breakpoints.desktop {
  padding: 0px 50px;
  }
}

.rcloseIcon {
  width: 20px;
  height: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
}

.reviewLabel {  
  font-weight: 600;
  font-size: 24px;
  line-height: 120%;
  letter-spacing: 0%;
  text-align: center;
  vertical-align: middle;
  padding:0px 20px;
  font-family: typography.$font-serif;
  @include breakpoints.desktop {
    font-weight: 700;
    font-size: 32px;
    margin-bottom: 5px;
    padding:0px;
  }
}

.reviewDescription {
  display: none;
  
  font-weight: 400;
  font-size: 16px;
  line-height: 120%;
  text-align: center;
  vertical-align: middle;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    display: block;
  }
}

.reviewSlotContainer {
  margin-top:10px;
  display: block;
  overflow: auto;
  margin-left:0px;
  padding: 0px 20px;
  @include breakpoints.desktop {
    margin-top: 20px;
    padding: 0px; 
  }
}

.rcontainerLeft {
  // background: var(--white);
  float: left;
  padding: 0%;
  width: 100%;
  @include breakpoints.desktop {
    max-width: 45%;
    width: 45%;
    padding-right: 10px;
  }
}

.rcontainerRight {
  // background: var(--white);
  float: right;
  width: 100%;
  padding-bottom: 20px;
  @include breakpoints.desktop {
    max-width: 45%;
    width: 45%;
    padding-left: 10px;
    padding-bottom: 0px;
  }
}

.reditSection {
  width: 100%;
  display: block;
  overflow: auto;
}

.redit {
  float: right;
  margin-right: 10px;
  cursor: pointer;
  margin-top: -2px;
  @include breakpoints.desktop {    
    float: left;
    margin-left: 5px;
    margin-right: 0px;
  }
}

.reditText {  
  font-weight: 400;
  font-size: 12px;
  letter-spacing: 5%;
  vertical-align: middle;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-thickness: 0%;
  margin-left: -2px;
  font-family: typography.$font-mont;
}

.rslotLabel {  
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 5%;
  vertical-align: middle;
  text-transform: uppercase;
  font-family: typography.$font-mont;
  color: var(--Blue-Dark, #003366);
  float: left;
  @include breakpoints.desktop {    
    font-weight: 700;
  }

}

.rslotDivider {
  border: 1px solid var(--blue-01);
  margin: 5px 0px;
}

.reditIcon {
  margin-left: 4px;
  margin-top: 3px;
}

.rslotDes {
  float: left;
}

.rofficeName {  
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  vertical-align: middle;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    font-size: 20px;
    font-weight: 600;
  }
}

.rofficeAddress {
  
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  vertical-align: middle;
  font-family: typography.$font-mont;
  padding-bottom: 6px;
  @include breakpoints.desktop {
    font-size: 16px;
    line-height: 24px;
  }
}

.rdoctorContainer {
  margin-bottom: 4px;
  width: 100%;
  display: block;
  overflow: auto;
  .rdocImg {
    float: left;
    width: auto;
  }
}

.rdoctorName {  
  font-weight: 700;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: middle;
  padding: 10px;
  width: auto;
  float: left;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    font-size: 20px;
  }
}

.rslotDateLabel {
  
  font-weight: 700;
  font-size: 20px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  vertical-align: middle;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    line-height: 28px;
    font-size: 20px;
  }
}

.rslotDateValue {
  
  font-weight: 400;
  font-size: 20px;
  line-height: 22.4px;
  letter-spacing: 0.32px;
  vertical-align: middle;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    font-size: 20px;
    line-height: 28px;
  }
}

.rptcontainer {
  padding-bottom: 20px;
  padding: 0px 20px;
  @include breakpoints.desktop {
    padding: 6px 0px;
  }
}

.rpatientLabel {  
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--Blue-Dark, var(--blue-01));
  float: left;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {    
    font-weight: 700;
    letter-spacing: 5%;
  }
}

.rPtLabel {
  
  font-weight: 600;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  font-family: typography.$font-mont;
  @include breakpoints.desktop {
    
    font-weight: 700;
  }

}

.rPtValue {
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  font-family: typography.$font-mont;
  overflow-wrap: anywhere;
  word-break: break-word;
  @include breakpoints.desktop {
    
  }

}

.rPatientName {
    width: 100%;
    float: left;
    padding: 5px 0px;
    min-width: 0;
    @include breakpoints.desktop {
      width: 100%;
      padding-bottom: 8px;
    }
}

.rPDOB {
  width: 100%;
  float: left;
  padding: 5px 0px;
  min-width: 0;
  @include breakpoints.desktop {
    width: 50%;
  }
}

.rPPhone {
  width: 100%;
  float: left;
  padding: 5px 0px;
  min-width: 0;
  @include breakpoints.desktop {
    width: 50%;
    text-align: left;
  }
}

.rEmail {
  width: 100%;
  padding: 5px 0px;
  min-width: 0;
  @include breakpoints.desktop {
    padding-top: 8px;
  }
}

.rpatientContainer {
  display: block; 
  overflow: auto;
  @include breakpoints.desktop {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
  }
}

.rbutton {
  
  width: 100%;
  height: 38px;
  border-radius: 100px;
  opacity: 1;
  gap: 8px;  
  font-size: 14px;
  line-height: 100%;
  display: block;
  margin: 0 auto;
  @include breakpoints.desktop {    
    font-weight: 700;
    width: 210px;
  }
}

.rcomButton {
  border-top: 1px solid var(--gray-09);
  padding-bottom: 12px;
  margin-left: -20px;
}

.rmodalFooter {
  position: sticky;
  bottom: 0;
  border-top: 1px solid var(--gray-08);
  padding:20px;
  @include breakpoints.desktop {
    position: initial;
    background: none;
    display: block;
    border: none;
    padding:0px 0px 20px 0px;
  }
}
